/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Cancel } from '../../media/images/Cancel';
import { AnalystTubeCountDatatablestyle } from './utils/Constant';
import ComponentTextInput from '../../Common/ComponentTextinput/ComponentTextInput';
import { showErrorToaster, showSuccessToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import { RootState } from '../../redux/rootState';
import { getChartListSuccess } from '../VesselInformation/redux/tubeChart/tubeChartSlice';
import ComponentSelectInput from '../../Common/ComponentSelectInput';
import { offsetValues } from '../VesselInformation/utils/tubeChartConstant';

interface IEnhanceTubeChartGridModal {
  open: boolean;
  handleClose: () => void;
  handleImport: () => void;
}

export default function CreateTubeChartGridModal({
  open, handleClose, handleImport,
}: IEnhanceTubeChartGridModal) {
  const { control } = useForm();
  const dispatch = useDispatch();
  const [errRow, setErrRow] = useState('');
  const [errTube, setErrTube] = useState('');
  const [offset, setOffset] = useState('0');
  const { chartList } = useSelector((state: RootState) => state.TubeChartReducer);

  const closeModal = () => {
    handleClose();
  };
  function createGrid(newRows: number, newTubes: number) {
    const result = [];

    for (let r = 0; r < newRows; r++) {
      for (let c = 0; c < newTubes; c++) {
        result.push({
          Position: `${r},${c}`,
          Stroke: '#FF000000',
          Fill: '#00FFFFFF',
        });
      }
    }

    return result;
  }

  const handleGenerate = () => {
    if (Number(errRow) > 100) {
      showErrorToaster('You can add upto 100 rows');
    } else if (Number(errTube) > 130) {
      showErrorToaster('You can add upto 130 tubes per row');
    } else if (Number(errRow) < 1 || Number(errTube) < 1) {
      showErrorToaster('The total number of rows and tubes per row cannot be 0');
    } else {
      const chart = chartList[0];

      const grid = createGrid(Number(errRow), Number(errTube));

      const payData = {
        ...chart,
        Offset: offset,
        NumOfRows: errRow,
        RowLength: errTube,
        CircleInfos: grid,
        RemovedConfig: {},
      };

      dispatch(getChartListSuccess([payData]));
      showSuccessToaster('Grid created successfully');
      closeModal();
    }
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={AnalystTubeCountDatatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Create New Grid
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>
        </div>
        <div className="analystTubeCountModalHeaderRowAlign">
          <div className="div_label_text" style={{ width: '90%', marginTop: '10px' }}>
            <label className="label_Style_Customer">Rows</label>
            <ComponentTextInput
              name="newRows"
              id="newRows"
              control={control}
              type="number"
              size="small"
              handleChange={(e, val) => setErrRow(val)}
              maxTextLength={3}
            />
          </div>
          <div className="div_label_text" style={{ width: '90%' }}>
            <label className="label_Style_Customer">Tubes per row</label>
            <ComponentTextInput
              name="newTubes"
              id="newTubes"
              control={control}
              type="number"
              size="small"
              handleChange={(e, val) => setErrTube(val)}
              maxTextLength={3}
            />
            {/* <p className="bayLengthErr">{errTube}</p> */}
          </div>
          <div className="div_label_text" style={{ width: '90%' }}>
            <label className="label_Style_Customer">Offset</label>
            <ComponentSelectInput
              name="newOffset"
              control={control}
              size="small"
              defaultValue="0"
              handleChange={(e) => setOffset(e)}
              entries={offsetValues}
            />
            {/* <p className="bayLengthErr">{errTube}</p> */}
          </div>

          <Button
            className="button_save_and_next"
            sx={{ height: 36, marginTop: '20px' }}
            onClick={handleGenerate}
          >
            Generate Grid
          </Button>
          <div className="customerInfo">
            OR
          </div>
          <Button
            className="button_save_and_next"
            sx={{ height: 36 }}
            onClick={handleImport}
          >
            Import from Library
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
